<template>
    <v-container class="sale-point-list">
        <v-container class="sale-point-list-container">
            <v-btn
                v-if="$can('create.points-of-sale')"
                color="#1976d2"
                class="create-btn"
                @click.stop="openFormDrawer"
            >
                <v-icon>mdi-plus</v-icon>Novo Ponto de Venda
            </v-btn>
            <list-point-of-sale
            @edit-point-of-sale="openFormDrawerToEdit">
            </list-point-of-sale>
        </v-container>
        <point-of-sale-form-drawer
            :drawer="drawer"
            :point-of-sale="pointOfSale"
            @close-drawer="drawer = !drawer"
        >
        </point-of-sale-form-drawer>
    </v-container>
</template>

<script>
import ListPointOfSale from "../../components/PointOfSale/ListPointOfSale";
import PointOfSaleFormDrawer from "../../components/PointOfSale/PointOfSaleFormDrawer";

export default {
    name: "PointOfSaleList",

    components: {
        ListPointOfSale,
        PointOfSaleFormDrawer,
    },

    data: () => ({
        drawer: false,
        pointOfSale: null,
    }),

    methods: {
        openFormDrawerToEdit(pointOfSale) {
            this.pointOfSale = pointOfSale;
            this.drawer = !this.drawer;
        },

        openFormDrawer() {
            this.pointOfSale = null;
            this.drawer = !this.drawer;
        }
    },

    watch: {
        drawer: function () {
            document.querySelector("body").style.overflow = 'hidden';
        }
    }
}
</script>

<style lang="scss" scoped>
.sale-point-list {
    background-color: #f0f0f0;
    height: 100%;
    &-container {
        padding: 20px;
        width: 100%;
    }
}
</style>
